import { AppProviders } from "@/providers";

function App() {
  return <AppProviders />;
}

export default App;
